export const WALLET_PATH = '/wallet' as const;
export const ROOT_PATH = `${WALLET_PATH}/:ownerType/:ownerId` as const;
export const ERROR_PATH = '/error' as const;
